import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Home } from '@otp/icons';
import BreadcrumbsMUI from '@mui/material/Breadcrumbs';
import { Typography } from '../typography';
import styles from './breadcrumbs.module.css';
const DefaultLink = ({ children }) => (_jsx("span", { className: styles.defaultLink, "data-testid": "default-link", children: children }));
export const Breadcrumbs = (props) => {
    const { items, Link = DefaultLink, icon = _jsx(Home, { className: styles.homeIcon, "data-testid": "home-icon" }), withoutDefaultLink = false, } = props;
    return (_jsxs(BreadcrumbsMUI, { separator: _jsx("span", { className: styles.breadcrumbSeparator, children: "\u203A" }), "aria-label": "breadcrumb", className: styles.wrapper, children: [withoutDefaultLink && icon, !withoutDefaultLink && _jsx(Link, { to: "/", children: icon }), items.map((item) => {
                if (item.url) {
                    return (_jsx(Link, { to: item.url, children: _jsx(Typography, { className: styles.itemLabel, children: item.label }) }, item.label));
                }
                return (_jsx(Typography, { variant: "subtitle2", className: styles.itemLabel, children: item.label }, item.label));
            })] }));
};
export default Breadcrumbs;
